import { Component, Inject, OnInit, Optional } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";
import { IConsentResult } from "@shared/interfaces/consent.interface";
import { ConsentService } from "@shared/services/consent.service";
import { UserService } from "@shared/services/user.service";
import { finalize, first } from "rxjs";

@Component({
  selector: "app-consent-dialog",
  templateUrl: "./consent-dialog.component.html",
  styleUrls: ["./consent-dialog.component.scss"],
})
export class ConsentDialogComponent implements OnInit {
  public isLoading = true;
  public consent?: IConsentResult;

  constructor(
    private userService: UserService,
    private consentService: ConsentService,
    private translateService: TranslateService,
    public snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<ConsentDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: { skipAcceptCall?: boolean }
  ) {
    this.dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.consentService
      .getLatestConsent(this.translateService.currentLang)
      .pipe(
        first(),
        finalize(() => (this.isLoading = false))
      )
      .subscribe({
        next: (consent: IConsentResult) => {
          this.consent = consent;
        },
        error: () => {
          this.snackBar.open(`❗ ${this.translateService.instant("common.error")}`, "OK", { duration: 5000 });
        },
      });
  }

  /**
   * Accepts consent and closes the dialog on success.
   * Skips API call when `skipAcceptCall` is enabled.
   */
  public accept(): void {
    if (this.data?.skipAcceptCall) {
      this.dialogRef.close(true);
      return;
    }

    this.isLoading = true;

    this.userService
      .acceptConsent()
      .pipe(
        first(),
        finalize(() => (this.isLoading = false))
      )
      .subscribe({
        next: () => this.dialogRef.close(true),
        error: () => {
          this.snackBar.open(`❗ ${this.translateService.instant("common.error")}`, "OK", { duration: 5000 });
        },
      });
  }
}
